const PrinterJobs = () => import('./PrinterJobs'),
    PrinterJob = () => import('./PrinterJob');

export default [{
    name: 'printer-jobs',
    path: '/admin/printer-jobs/:page',
    component: PrinterJobs,
    props: true,
}, {
    name: 'printer-job',
    path: '/admin/printer-job/:id',
    component: PrinterJob,
    props: true,
}];
